<template>
    <v-card
        class="my-3 pa-3"
        :class="{ 'soli-round': $vuetify.breakpoint.smAndUp }"
        flat
    >
        <div
            v-if="question"
            class="pa-3 pb-2 soli-grey text-align-start font-weight-bold text-lg"
        >
            <slot name="question"></slot>
            <div v-if="required" class="grey--text caption">*required</div>
            <slot name="action"></slot>
            <div class="absolute right-0 my-6 py-05 mr-7 top-0">
                <slot name="end"></slot>
            </div>
        </div>
        <div class="pa-2 soli-grey">
            <slot name="response"></slot>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        question: {
            type: Boolean,
            default: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
